export default __webpack_public_path__ + "static/media/convention_example.5fea5563.png";